import styled, { keyframes } from 'styled-components';
import * as variables from 'styles/variables';
import { Row } from 'components/Styled/Basic';
import React from 'react';

const spin = keyframes` 
	100% {
		transform: rotate(360deg);
	}
`;

const sizes = {
	s: {
		width: '10px',
	},
	m: {
		width: '20px',
	},
	l: {
		width: '40px',
	},
};

const dash = keyframes` 
	0% {
		stroke-dasharray: 1px, 200px;
		stroke-dashoffset: 0;
	} 
	50% {
		stroke-dasharray: 100px, 200px;
		stroke-dashoffset: -15px;
	} 
	100% {
		stroke-dasharray: 100px, 200px;
		stroke-dashoffset: -120px;
	}
`;

export const LoaderSvg = styled.svg`
	width: ${({ size }) => sizes[size]?.width ? sizes[size].width : '50px'};
	display: inline-block;
	animation: ${spin} 2s infinite linear;
`;

const Circle = styled.circle`
	stroke: ${variables.primaryColors?.primary || '#1976d2'};
	stroke-width: 3.6;
	fill: none;
	stroke-linecap: round;
	animation: ${dash} 1.4s ease-in-out infinite;
	stroke-dasharray: 80px, 200px;
	stroke-dashoffset: 0;
`;

export const Loader = ({ size }) => (
	<LoaderSvg
		size={size}
		viewBox="0 0 50 50"
	>
		<Circle
			cx="25"
			cy="25"
			r="20"
		/>
	</LoaderSvg>
);

export const LoaderWithContainer = ({ size = 'm', minHeight = 200 }) => (
	<Row
		isAuto
		justifyContent="center"
		alignItems="center"
		minHeight={minHeight}
	>
		<Loader size={size}	/>
	</Row>
);
